<template>
  <div class="hello">
    <!--首屏区域-->
    <div class="first-container first-container1">
      <!-- <div class="first-box">
        <img class="nav-logo" src="../assets/p1-左上角 logo@2x.png" alt="" />
      </div>
      <div class="title-text">AI洞察真实世界</div> -->
    </div>
    <!--关于我们-->
    <section
      id="company-profile"
      name="company-profile"
      class="company-profile___XrpzK"
    >
      <div
        class="
          title-type___2QPgq
          company-profile-module-title___1Wkhz
          title-type-global
        "
      >
        <div class="fadeAppear___1hoE6 visible___3Z4Hr">
          <div style="display: none"></div>
          <h1
            class="title-type-center-title___2u1RY undefined title-type-title"
          >
            关于AIGC-X
          </h1>
        </div>
        <div class="fadeAppear___1hoE6 visible___3Z4Hr">
          <div style="display: none"></div>
          <div class="intro-container">
            <p class="intro-tips">
              传播内容认知全国重点实验室、中国科学技术大学、合肥综合性国家科学中心人工智能研究院联合推出的AI生成内容检测工具，可以快速分辨出内容是机器生成还是人工生成的。
            </p>
            <p class="intro-tips">
              AIGC技术的突破，将会大大推动人工智能在内容领域的全面变革。然而，AIGC在虚假信息、学术造假、网络钓鱼等任务中的滥用，严重阻碍新技术在媒体和教育等领域的应用。AIGC-X是实验室研究AI自我治理机制的重要成果，是探索如何从技术角度解决AIGC安全问题的初步尝试。结合内容识别、内容溯源等技术，AIGC-X能够有效的推动AI风险管理、安全审查和评估技术的发展，为建立安全可信AIGC生态的基础提供技术方案与支撑。
            </p>
          </div>
        </div>
      </div>
      <div class="fadeAppear___1hoE6 visible___3Z4Hr">
        <div style="display: none"></div>
        <div class="intro-card___2pyIY">
          <div class="intro-card-text___2HNrP intro-card-text-left___17FKG">
            <div class="intro-card-text-content___1de2s">
              <h1 class="intro-card-text-content-title___1u86h">技术原理</h1>
              <p class="intro-card-text-content-intro___2w79Q">
                AI文本生成模型是在海量文本语料基础上，经过自回归式语言建模的大规模训练得到，模型通过计算下一个单词的概率分布逐步完成整个文本内容的生成。
              </p>
              <p class="intro-card-text-content-intro___2w79Q">
                AIGC-X尝试采用算法融合与知识驱动的人工智能框架，使用深度建模来捕捉困惑度、突现频次等隐式特征，学习得到机器生成文本与人工生成文本的分布差异。
              </p>

              <a class="link___c01hW" href="#try">
                <div
                  class="
                    link___c01hW
                    more___FVQ2r
                    more-new___2QMxd
                    undefined
                    intro-card-text-content-more___1L6qx
                  "
                >
                  <span class="more-text">点击试用</span>
                </div>
              </a>
            </div>
          </div>
          <img
            class="intro-card-image___2nwhu"
            src="../assets/588ku_37d4385e6004e6e11df58a5c1a294b4a_266793@2x.png"
            alt=""
          />
        </div>
      </div>
    </section>
    <!--测试案例-->
    <div class="testcase-container">
      <span class="test-title">测试案例</span>
      <div class="test-case-box">
        <div class="test-case">
          <div style="margin-bottom: 10px">
            想踢足球的时候：没有场地，草地可以，砖地可以，土地可以，水泥地也可以；没有球门，捡两块砖可以，摆俩书包可以。篮球就不一样了，篮球场必须要有篮筐，必须地面要平，以及必须要有一个篮球。足球为啥是第一运动？因为足球在推广过程中的门槛实在太低了，低到他对你的经济要求几乎为0，对环境要求也低的可怜，所以足球有着其他运动比不了的广阔群众基础。
          </div>
          <div style="margin-bottom: 10px">
            <img src="../assets/人工.png" alt="" class="result-icon" /><span
              style="color: #3d84ff"
              >AIGC-X：该内容是人工生成的😊</span
            >
          </div>
          <div style="margin-bottom: 10px">置信度：89.45%</div>
          <a class="link___c01hW" href="#try">
            <div class="click-test">
              <span class="more-text" @click="toTry(1)">点击试用</span>
            </div>
          </a>
        </div>
        <div class="test-case">
          <div style="margin-bottom: 10px">
            足球被称为世界第一运动是因为它在全球的普及度非常高，拥有大量的支持者和粉丝。根据统计数据，足球是世界上最受欢迎的运动，有超过4亿人口在世界各地玩足球。足球的简单规则和基本设备需求使它成为了一项易于参与的运动，并且它在世界范围内的盛行也使得它成为了一项全球性的文化现象。此外，足球还是世界上最受关注的体育赛事之一，其中包括世界杯和欧洲冠军联赛等。
          </div>
          <div style="margin-bottom: 10px">
            <img src="../assets/机器.png" alt="" class="result-icon" /><span
              style="color: #ff3d3d"
              >AIGC-X：该内容是机器生成的😜</span
            >
          </div>
          <div style="margin-bottom: 10px">置信度：93.80%</div>
          <a class="link___c01hW" href="#try">
            <div class="click-test">
              <span class="more-text" @click="toTry(2)">点击试用</span>
            </div>
          </a>
        </div>
        <div class="test-case">
          <div style="margin-bottom: 10px">
            作为一种人工智能技术，对话生成模型，如 ChatGPT，仍然面临着很多挑战。
            1.
            理解多样性：生成的对话可能存在偏见和不准确的信息，因为模型是基于大量的文本数据进行训练的。 
            2.
            语言复杂性：自然语言具有复杂的语法和语义，模型必须能够理解这些复杂的关系才能生成准确的回答。 3.
            数据隐私：用于训练生成模型的数据可能包含敏感信息，因此必须开发机制来保护隐私。
          </div>
          <div style="margin-bottom: 10px">
            <img src="../assets/机器.png" alt="" class="result-icon" /><span
              style="color: #ff3d3d"
              >AIGC-X：该内容是机器生成的😜</span
            >
          </div>
          <div style="margin-bottom: 10px">置信度：77.60%</div>
          <a class="link___c01hW" href="#try">
            <div class="click-test">
              <span class="more-text" @click="toTry(3)">点击试用</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!--在线服务-->
    <div class="use-container use-container1">
      <div class="first-box">
        <span class="first-box-title" id="try">功能体验区</span>
      </div>
      <div class="textarea-box">
        <textarea name="" id="" cols="30" rows="10" v-model="query" placeholder="文本长度不超过512个字符"></textarea>

        <div class="tipbtn-box">
          <div class="game-box">
            <el-link
              type="success"
              @click="dialogVisible = true"
              class="game-link"
              >人机大战小游戏<i class="el-icon-view el-icon--right"></i
            ></el-link>
          </div>
          <div class="tips-box">
            <div class="tips-state" @click="toDisclaimers">
              <i class="el-icon-warning" style="font-size: 20px"></i>
              本工具只测试鉴别内容是否为AI生成，内容正误请使用其他工具进行判别。
            </div>
            <img
              v-if="isHuman == '1' || isHuman == '0'"
              class="use-result-image"
              src="../assets/AI.png"
              alt=""
            />
            <span
              class="result"
              v-if="isHuman == '1'"
              style="color: #ff3d3d; font-size: 18px"
              >AIGC-X：该内容是机器生成的😜</span
            >
            <span
              class="result"
              v-if="isHuman == '0'"
              style="color: rgb(26, 226, 32); font-size: 18px"
              >AIGC-X：该内容是人工生成的😊</span
            >
          </div>

          <div class="btn-box">
            <!-- <el-button
              type="warning"
              size="medium "
              @click="dialogVisible = true"
              >猜一猜</el-button
            > -->
            <el-button type="" size="medium " @click="getGPT"
              >添加随机文本</el-button
            >
            <el-button type="primary" size="medium" @click="getResult"
              >开始检测</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!--产品不足-->
    <section
      id="company-profile"
      name="company-profile"
      class="company-profile___XrpzK2"
    >
      <div
        class="
          title-type___2QPgq
          company-profile-module-title___1Wkhz
          title-type-global
        "
      >
        <div class="fadeAppear___1hoE6 visible___3Z4Hr">
          <div style="display: none"></div>
          <h1
            class="title-type-center-title___2u1RY undefined title-type-title"
          >
            未来工作
          </h1>
        </div>
        <div class="case-contain">
          <div class="case-box">
            <img class="case-image" src="../assets/insuff1.png" alt="" />

            <div class="case-desc">AIGC-X目前只支持中文内容的检测。</div>
          </div>
          <div class="case-box">
            <img class="case-image" src="../assets/insuff2.png" alt="" />

            <div class="case-desc">
              由于短文本蕴含的创作源头信息相对较少，AIGC-X对较短文本，尤其是一个短语的检测精度有待提高。
            </div>
          </div>
          <div class="case-box">
            <img class="case-image" src="../assets/insuff3.png" alt="" />

            <div class="case-desc">
              AIGC-X聚焦于通用文体的检测，其领域泛化性能有待提升。受限于样本数量，AIGC-X对于ChatGPT生成的文书、诗词、
              对联、代码等文体检测能力相对有限。
            </div>
          </div>
          <div class="case-box">
            <img class="case-image" src="../assets/insuff4.png" alt="" />

            <div class="case-desc">
             AIGC-X对抗攻击的鲁棒性较弱。对于AI生成内容，加入人为的修改后，AIGC-X就会更倾向于将内容判定为人工生成的。
            </div>
          </div>
          <div class="case-box">
            <img class="case-image" src="../assets/insuff5.png" alt="" />
            <div class="case-desc">
              内容生成与内容判别具有一定的对抗性，生成技术以生成更具有欺骗性的内容为目标，AIGC-X需要在博弈过程中不断升级。
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--底部版权-->
    <div class="bottom-version">
      <div class="version-box">
        <span class="bottom-text">主管单位： </span>
        <img class="version-image" src="../assets/人民日报1.png" alt="" />
        <span class="bottom-text">依托单位： </span>
        <img class="version-image" src="../assets/人民网1.png" alt="" />
        <span class="bottom-text">建设单位: </span>
        <img class="syslogo" src="../assets/实验室.png" alt="" /><span
          class="bottom-text"
          >传播内容认知全国重点实验室</span
        >
      </div>
      <div class="version-box">
        <span class="bottom-text"
          >联系方式：sklccc@people.cn 地址：北京市朝阳区金台西路2号
        </span>
      </div>
      <div class="version-box">
        <span class="bottom-text"
          >京ICP备12004265号-27 京公网安备11000002000008号
        </span>
      </div>
      <el-dialog
        title="人机大战小游戏"
        :visible.sync="dialogVisible"
        width="80%"
        :before-close="handleClose"
        center
      >
        <div class="el-dialog-div" id="el-dialog-div">
          <div
            class="conversation-box"
            v-for="item in guessList"
            :key="item.index"
          >
            <div class="left">
              <el-avatar
                style="margin-right: 10px"
                shape="square"
                :size="50"
                :src="'http://g5.guodata.com/image/ab8c6fb76278e4c09b3ce3e94f414b79.jpeg'"
              ></el-avatar>
              <el-card
                shadow="always"
                :body-style="{
                  padding: '20px',
                  width: '55vw',
                  'min-width': '700px',
                  'font-size': '22px',
                }"
                ><span v-html="item.ask"></span>
                <el-link v-if="isFirst" type="primary" @click="getGuessGPT"
                  >猜一猜</el-link
                >

                <div class="aigc-dialog-btn-box" v-if="item.guessed">
                  <el-button
                    type="danger"
                    size="mini"
                    round
                    plain
                    @click="getGuessResult(1)"
                    :disabled="
                      (isHumanGuess == 0 || isHumanGuess == 1) && isRequesting
                    "
                    >机器生成</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    round
                    plain
                    @click="getGuessResult(0)"
                    :disabled="
                      (isHumanGuess == 0 || isHumanGuess == 1) && isRequesting
                    "
                    >人工生成</el-button
                  >
                </div>
              </el-card>
            </div>
            <div class="right" v-if="item.answer">
              <el-card
                shadow="always"
                :body-style="{
                  padding: '20px',
                  width: '20vw',
                  'min-width': '200px',
                  'background-color': 'rgb(230, 233, 196)',
                  'font-size': '22px',
                }"
                >{{ item.answer }}</el-card
              >

              <el-avatar
                style="margin-left: 10px"
                shape="square"
                :size="50"
                :src="'http://g5.guodata.com/image/user1.png'"
              ></el-avatar>
            </div>
            <div class="left" v-if="item.aigc">
              <el-avatar
                style="margin-right: 10px"
                shape="square"
                :size="50"
                :src="'http://g5.guodata.com/image/insuff6.png'"
              ></el-avatar>
              <el-card
                shadow="always"
                :body-style="{
                  padding: '20px',
                  width: '35vw',
                  'min-width': '400px',
                  'font-size': '22px',
                }"
                ><span v-html="item.aigc"></span
              ></el-card>
            </div>
            <div class="left" v-if="item.standard">
              <el-avatar
                style="margin-right: 10px"
                shape="square"
                :size="50"
                :src="'http://g5.guodata.com/image/ab8c6fb76278e4c09b3ce3e94f414b79.jpeg'"
              ></el-avatar>
              <el-card
                shadow="always"
                :body-style="{
                  padding: '20px',
                  width: '55vw',
                  'min-width': '700px',
                  'font-size': '22px',
                }"
                ><span v-html="item.standard"></span>
                <el-link
                  class="guessButton"
                  type="primary"
                  @click="getGuessGPT"
                  v-if="!item.guessed"
                  >再猜一次</el-link
                ></el-card
              >
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <!-- <el-button type="" size="mini" @click="getGuessGPT">猜一猜</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getGPTCheckInfo, getGPTGuess, postGPTGuess } from "@/api/art.js";
import { genSignature } from "../utils/signature";
import { chatEnums } from "../utils/chatGPT";
export default {
  name: "HelloWorld",
  data() {
    return {
      currentIndex: 1,
      dialogVisible: false,
      msg: "Welcome to Your Vue.js App",
      guessQuery: "",
      guessList: [
        {
          ask: "大家好，我是比赛主持人黑哨。</br>跟AIGC-X比一比，猜猜问题的答案是机器生成的还是人工生成的。</br>请点击猜一猜开始使用吧~",
          answer: "",
          standard: "",
          aigc: "",
          guessed: false,
        },
      ],
      guessData: "",
      query: "",
      isHuman: "",
      isHumanGuess: "",
      secretId: "06488affa3467c04aac7f37f8683b9cb",
      signature: "",
      timestamp: new Date().getTime(),
      nonce: Math.floor(Math.random() * 10000),
      isRequesting: true,
      isRight: "",
      type: "",
      isFirst: true,
    };
  },
  methods: {
    toTry(mode) {
      if (mode == 1) {
        this.query =
          "想踢足球的时候：没有场地，草地可以，砖地可以，土地可以，水泥地也可以；没有球门，捡两块砖可以，摆俩书包可以。篮球就不一样了，篮球场必须要有篮筐，必须地面要平，以及必须要有一个篮球。足球为啥是第一运动？因为足球在推广过程中的门槛实在太低了，低到他对你的经济要求几乎为0，对环境要求也低的可怜，所以足球有着其他运动比不了的广阔群众基础。";
      } else if (mode == 2) {
        this.query =
          "足球被称为世界第一运动是因为它在全球的普及度非常高，拥有大量的支持者和粉丝。根据统计数据，足球是世界上最受欢迎的运动，有超过4亿人口在世界各地玩足球。足球的简单规则和基本设备需求使它成为了一项易于参与的运动，并且它在世界范围内的盛行也使得它成为了一项全球性的文化现象。此外，足球还是世界上最受关注的体育赛事之一，其中包括世界杯和欧洲冠军联赛等。";
      } else {
        this.query =
          "作为一种人工智能技术，对话生成模型，如 ChatGPT，仍然面临着很多挑战。 1. 理解多样性：生成的对话可能存在偏见和不准确的信息，因为模型是基于大量的文本数据进行训练的。  2. 语言复杂性：自然语言具有复杂的语法和语义，模型必须能够理解这些复杂的关系才能生成准确的回答。 3. 数据隐私：用于训练生成模型的数据可能包含敏感信息，因此必须开发机制来保护隐私。";
      }
    },
    handleClose(done) {
      // this.$confirm("不再猜一次了吗？", {
      //   confirmButtonText: "不猜了",

      //   cancelButtonText: "继续猜",

      //   type: "primary",
      // })
      //   .then((_) => {
      //     this.dialogVisible = false;
      //   })
      //   .catch((_) => {});
      this.guessList = [
        {
          ask: "您好呀，欢迎来到AIGC-X智能检测世界！</br>我是AI检测助手晓助，可以帮您检测生成文本的类型，包括人工生成和机器生成。请点击猜一猜开始使用吧~",
          answer: "",
          standard: "",
          aigc: "",
          guessed: false,
        },
      ];
      this.currentIndex = 0;
      this.dialogVisible = false;
      this.isHumanGuess = "";
      this.isFirst = true;
    },
    async getResult() {
      if (this.query == "") {
        this.$message({
          type: "warning",
          message: "请输入检测文本",
        });
      } else if (this.query.length <= 10) {
        this.$message({
          type: "warning",
          message: "检测文本长度必须大于10个文字",
        });
      } else {
        if (this.query.length >= 512) {
          this.$message({
            type: "warning",
            message: "检测文本长度超过最大限制512,已为您自动截断",
          });
          this.query = this.query.substring(0, 511);
        }

        this.getSign();
        const res = await getGPTCheckInfo({
          content: this.query,
          signature: this.signature,
          secretId: this.secretId,
          timestamp: this.timestamp,
          nonce: this.nonce,
          type: 255,
          version: "v1.1",
          businessId: "0",
          signatureMethod: "",
        });
        if (res.code == 200) {
          this.$message({ type: "success", message: "获取结果成功" });
          this.isHuman = res.data.hittype;
        }
      }
    },
    toDisclaimers() {
      let routeData = this.$router.resolve({ path: "/disclaimers" });
      window.open(routeData.href, "_blank");
    },
    async getGuessResult(type) {
      if (this.guessQuery == "") {
        this.$message({
          type: "warning",
          message: "请输入检测文本",
        });
      } else if (this.guessQuery.length <= 10) {
        this.$message({
          type: "warning",
          message: "检测文本长度必须大于10个文字",
        });
      }
      // else if (this.guessQuery.length >= 512) {
      //   this.$message({
      //     type: "warning",
      //     message: "检测文本长度超过最大限制",
      //   });
      // }
      else {
        this.type = type;
        this.isHumanGuess = this.guessData.label;
        if (type == 0 && this.isHumanGuess == 0) {
          //猜人工
          this.guessList[this.currentIndex].answer = "我猜是人工生成的！";
          this.guessList[this.currentIndex].guessed = false;
          this.guessList[this.currentIndex].standard =
            this.guessData.label == 0
              ? "这个答案是通过人工生成的，你猜对了吗？"
              : "这个答案是通过机器生成的，你猜对了吗？";

          this.guessList[this.currentIndex].aigc =
            this.guessData.m_label == 0
              ? "AIGC-X：我猜是人工生成的！"
              : "AIGC-X：我猜是机器生成的！";
          this.currentIndex = this.currentIndex + 1;

          this.$forceUpdate();
          // this.$message({
          //   type: "success",
          //   message: "恭喜您猜对了，该结果通过人工生成",
          // });
          let ele = document.getElementById("el-dialog-div");
          setTimeout(function () {
            //设置滚动条到最底部
            ele.scrollTop = ele.scrollHeight;
          }, 0);
        } else if (type == 0 && this.isHumanGuess == 1) {
          //猜人工
          this.guessList[this.currentIndex].answer = "我猜是人工生成的！";
          this.guessList[this.currentIndex].standard =
            this.guessData.label == 0
              ? "这个答案是通过人工生成的，你猜对了吗？"
              : "这个答案是通过机器生成的，你猜对了吗？";

          this.guessList[this.currentIndex].aigc =
            this.guessData.m_label == 0
              ? "AIGC-X：我猜是人工生成的！"
              : "AIGC-X：我猜是机器生成的！";
          this.guessList[this.currentIndex].guessed = false;

          this.currentIndex = this.currentIndex + 1;

          // this.$message({
          //   type: "error",
          //   message: "很抱歉您猜错了，该结果通过机器生成！",
          // });
          let ele = document.getElementById("el-dialog-div");
          setTimeout(function () {
            //设置滚动条到最底部
            ele.scrollTop = ele.scrollHeight;
          }, 0);
        } else if (type == 1 && this.isHumanGuess == 1) {
          //猜机器
          this.guessList[this.currentIndex].answer = "我猜是机器生成的！";
          this.guessList[this.currentIndex].standard =
            this.guessData.label == 0
              ? "这个答案是通过人工生成的，你猜对了吗？"
              : "这个答案是通过机器生成的，你猜对了吗？";

          this.guessList[this.currentIndex].aigc =
            this.guessData.m_label == 0
              ? "AIGC-X：我猜是人工生成的！"
              : "AIGC-X：我猜是机器生成的！";
          this.guessList[this.currentIndex].guessed = false;

          this.currentIndex = this.currentIndex + 1;

          // this.$message({
          //   type: "success",
          //   message: "恭喜您猜对了，该结果通过机器生成",
          // });
          let ele = document.getElementById("el-dialog-div");
          setTimeout(function () {
            //设置滚动条到最底部
            ele.scrollTop = ele.scrollHeight;
          }, 0);
        } else {
          //猜机器
          this.guessList[this.currentIndex].answer = "我猜是机器生成的！";
          this.guessList[this.currentIndex].standard =
            this.guessData.label == 0
              ? "这个答案是通过人工生成的，你猜对了吗？"
              : "这个答案是通过机器生成的，你猜对了吗？";

          this.guessList[this.currentIndex].aigc =
            this.guessData.m_label == 0
              ? "AIGC-X：我猜是人工生成的！"
              : "AIGC-X：我猜是机器生成的！";
          this.guessList[this.currentIndex].guessed = false;
          this.currentIndex = this.currentIndex + 1;

          // this.$message({
          //   type: "error",
          //   message: "很抱歉您猜错了，该结果通过人工生成",
          // });
          let ele = document.getElementById("el-dialog-div");
          setTimeout(function () {
            //设置滚动条到最底部
            ele.scrollTop = ele.scrollHeight;
          }, 0);
        }
        this.getGuessPostSign();
        const res = await postGPTGuess({
          id: this.guessData.id,
          h_label: type,
          type: 255,
          version: "v1.1",
          businessId: "0",
          signatureMethod: "",
          secretId: this.secretId,
          timestamp: this.timestamp,
          nonce: this.nonce,
          signature: this.signature,
        });
      }
    },
    getSign() {
      this.timestamp = new Date().getTime();
      this.nonce = Math.floor(Math.random() * 10000);
      const sign = genSignature("2835c49feaad72da7458b481498c20e4", {
        content: this.query,
        type: 255,
        version: "v1.1",
        businessId: "0",
        signatureMethod: "",
        secretId: this.secretId,
        timestamp: this.timestamp,
        nonce: this.nonce,
      });
      this.signature = sign;
    },
    getGuessQuerySign() {
      this.timestamp = new Date().getTime();
      this.nonce = Math.floor(Math.random() * 10000);
      const sign = genSignature("2835c49feaad72da7458b481498c20e4", {
        type: 255,
        version: "v1.1",
        businessId: "0",
        signatureMethod: "",
        secretId: this.secretId,
        timestamp: this.timestamp,
        nonce: this.nonce,
      });
      this.signature = sign;
    },
    getGuessPostSign() {
      this.timestamp = new Date().getTime();
      this.nonce = Math.floor(Math.random() * 10000);
      const sign = genSignature("2835c49feaad72da7458b481498c20e4", {
        id: this.guessData.id,
        h_label: this.type,
        type: 255,
        version: "v1.1",
        businessId: "0",
        signatureMethod: "",
        secretId: this.secretId,
        timestamp: this.timestamp,
        nonce: this.nonce,
      });
      this.signature = sign;
    },

    async getGPT() {
      this.isHuman = 2;
      this.getGuessQuerySign();
      const res = await getGPTGuess({
        type: 255,
        version: "v1.1",
        businessId: "0",
        signatureMethod: "",
        secretId: this.secretId,
        timestamp: this.timestamp,
        nonce: this.nonce,
        signature: this.signature,
      });
      this.guessData = res.data;
      this.query = this.guessData.answer;
    },
    async getGuessGPT() {
      this.isFirst = false;
      this.isHumanGuess = 2;
      this.getGuessQuerySign();
      const res = await getGPTGuess({
        type: 255,
        version: "v1.1",
        businessId: "0",
        signatureMethod: "",
        secretId: this.secretId,
        timestamp: this.timestamp,
        nonce: this.nonce,
        signature: this.signature,
      });
      this.guessData = res.data;
      this.guessList[this.currentIndex] = {
        ask: `问：${this.guessData.question}</br>答：${this.guessData.answer}`,
        answer: "",
        index: this.currentIndex,
        standard: "",
        aigc: "",
        guessed: true,
      };
      this.guessQuery = this.guessList[this.currentIndex].ask;
      this.$forceUpdate();
      let ele = document.getElementById("el-dialog-div");
      setTimeout(function () {
        //设置滚动条到最底部
        ele.scrollTop = ele.scrollHeight;
      }, 0);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tips-state {
  cursor: pointer;
  width: 100vw;
  font-size: 18px;
  margin-bottom: 30px;
  min-width: 800px;
  position: relative;
  bottom: 15px;
}
.title-text {
  font-size: 110px;
  background-image: linear-gradient(top, #fdffff, #0febff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.intro-container {
  padding: 10px 10px 10px 10px;
}
.conversation-box {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  flex-wrap: wrap;
}
.left {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-self: flex-start;
}
.right {
  display: flex;
  flex-direction: row;
  align-self: flex-end;
}
.game-box {
  margin-top: 20px;
  width: 300px;
  height: 26px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #ffffff;
  opacity: 1;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  top: 40px;
  right: 40px;
  min-width: 300px;
}
.nav-logo {
  position: absolute;
  left: 0.5vw;
  top: 30px;
  width: 18vw;
  max-width: 122px;
  min-width: 122px;
}
.first-container {
  /* background-color: #edf4ff; */
  /* background-image: url("https://fanyiapp.cdn.bcebos.com/cms/image/eab6731f7ef5c2b5ddef8ea51c349d8e.jpg"); */
  background-image: url("../assets/firstbackground4.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 0;
  padding: 110px 0 0;
}
.first-container1 {
  font-size: 24px;
  font-weight: 700;
  height: 50vw;
  justify-content: center;
  padding-top: 0;
  width: 100%;
  align-items: center;
  display: flex;
  /* min-width: 450px; */
  max-height: 1600px;
  min-height: 600px;
  min-width: 1200px;
}
.use-container {
  /* background-color: #edf4ff; */
  /* background-image: url("https://fanyiapp.cdn.bcebos.com/cms/image/eab6731f7ef5c2b5ddef8ea51c349d8e.jpg"); */
  background-image: url("../assets/17e9c258a189ee3a4a969dca3db7b63.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: 110%;
  margin-top: 0;
}
.use-container1 {
  font-size: 24px;
  font-weight: 700;
  height: 80vw;
  justify-content: flex-start;
  padding-top: 0;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  max-height: 1000px;
  min-height: 700px;
  min-width: 1200px;
}

.test-container {
  /* background-color: #edf4ff; */
  /* background-image: url("https://fanyiapp.cdn.bcebos.com/cms/image/eab6731f7ef5c2b5ddef8ea51c349d8e.jpg"); */
  background-image: url("../assets/firstbackground.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 0;
  padding: 120px 0 0;
}
.test-container1 {
  font-size: 24px;
  font-weight: 700;
  height: 100vh;
  justify-content: center;
  padding-top: 0;
  width: 100%;
  align-items: center;
  display: flex;
}
.tips-state {
  width: 70vw;
  font-size: 18px;
  margin-bottom: 10px;
  min-width: 800px;
  position: relative;
  bottom: 15px;
}
.first-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 30px;
  margin-bottom: 20px;
  align-items: flex-start;
}

.first-box-title {
  color: #fff;
  font-family: PingFangSC-Thin;
  font-size: 50px;
  font-weight: 540;
  letter-spacing: 0;
  line-height: 48px;
  margin-top: 50px;
}
.first-box-image {
  background: url("../assets/image2.png") 50% no-repeat;
  background-size: contain;
  height: 180px;
  margin-bottom: 34px;
  width: 900px;
  font-size: 100px;

  /* background-image: linear-gradient(180deg, #84a0dc 0%, #435fe8 100%);
  -webkit-background-clip: text;
  color: transparent; */
}
.case-image {
  width: 4vw;
  height: 4vw;
  border-radius: 8px;
  margin-right: 20px;
  max-width: 60px;
  max-height: 60px;
  min-width: 40px;
  min-height: 40px;
}
.case-contain {
  padding: 5px 30px 5px 10px;
  max-width: 1128px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.case-box {
  margin: 5px 5px 5px 5px;
  display: flex;
  flex-direction: row;
}
.case-desc {
  min-width: 78vw;
  max-height: 30vh;
  padding-right: 4px;
  /* overflow-y: auto; */
  color: #333;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.button-box {
  position: relative;
  left: 290px;
}
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
}
.btn {
  position: relative;
  margin-top: 30px;
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background-color: rgb(35, 31, 31);
  color: white;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1em;
  min-height: 3rem;
  font-weight: 600;
  border-radius: 8px;
}
.btn1 {
  position: relative;
  margin-top: 30px;
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background-color: #409eff;
  color: white;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1em;
  min-height: 3rem;
  font-weight: 600;
  border-radius: 8px;
}
textarea {
  font-size: 14px;
  border-radius: 15px;
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  opacity: 0.2;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  /* background: transparent; */
  display: inline-block;
  text-align: start;
  -webkit-appearance: textarea;
  background-color: rgb(244, 244, 244);
  -webkit-rtl-ordering: logical;
  flex-direction: column;
  resize: auto;
  cursor: text;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  margin: 0em;
  font: 400 16px Arial;
  border-image: initial;
  padding: 2px;
  min-width: 30vw;
  position: relative;
  right: 110px;
  top: 40px;
  color: rgb(234, 242, 243);
  width: 60vw;
  height: 20vw;
  background: rgba(54, 235, 232, 0.12);
  border: 1px solid #36ebe7;
  opacity: 1;
  border-radius: 12px;
  resize: none;
  min-width: 600px;
  min-height: 200px;
}
.company-profile___XrpzK {
  max-width: 1128px;
  margin-right: auto;
  margin-bottom: 100px;
  margin-left: auto;
  padding-top: 80px;
  max-height: 1100px;
  min-height: 600px;
  min-width: 1128px;
}
.el-button--medium {
  width: 130px;
  font-size: 14px;
  border-radius: 3px;
  height: 40px;
}
.el-dialog-div {
  height: 60vh;
  overflow: auto;
  padding: 10px 10px 20px 10px;
  min-height: 400px;
}
.icon {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
.company-profile___XrpzK1 {
  border-top: 1px solid #e5e7eb;
  max-width: 1128px;
  margin-right: auto;
  margin-bottom: 100px;
  margin-left: auto;
  padding-top: 30px;
}
.company-profile___XrpzK2 {
  max-width: 1128px;
  margin-right: auto;
  margin-bottom: 100px;
  margin-left: auto;
  padding-top: 30px;
  max-height: 1100px;
  min-height: 360px;
  min-width: 1128px;
}
.game-link {
  font-size: 20px;
}
.tipbtn-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 60vw;
  min-width: 500px;
  min-height: 200px;
  position: relative;
  min-width: 600px;
  top: 20px;
}
.guessButton {
  position: relative;
  bottom: 2px;
}
.title-type___2QPgq {
  max-width: 1128px;
  margin: 0 auto;
}
.aigc-dialog-btn-box {
  /* margin-top:20px ; */
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.company-profile___XrpzK .company-profile-module-title___1Wkhz {
  margin-bottom: 96px;
}
.title-type-center-title___2u1RY {
  margin: 0 0 20px;
  color: #392121;
  font-weight: 540;
  font-size: 50px;
  line-height: 54px;
  text-align: center;
}
.fadeAppear___1hoE6.visible___3Z4Hr {
  animation-name: fadeIn___2Wu-r;
  animation-play-state: running;
}
.intro-card___2pyIY {
  position: relative;
  max-width: 1128px;
  margin-top: 0;
  margin-bottom: 112px;
}
.intro-card-text-left___17FKG {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin: 0 0 0 64px;
  padding: 56px 48px 48px 0;
}
.intro-card-text___2HNrP {
  max-width: 1072px;
  height: 340px;
  margin: 0 64px 0 0;
  padding: 56px 0 48px 64px;
  background-color: #f7f8fa;
  border-radius: 8px;
  position: relative;
  left: 70px;
  /* width: 75vw; */
}
.intro-card-text-left___17FKG .intro-card-text-content___1de2s {
  position: relative;

  padding: 0 0 0 60px;
}
.intro-card-text-content___1de2s {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 50%;
  height: 336px;
  padding: 0 60px 0 0;
}
.intro-card-image___2nwhu {
  position: absolute;
  bottom: 40px;
  width: 50%;
  height: 440px;
  object-fit: cover;
  border-radius: 8px;
}
.intro-card-text-content-title___1u86h {
  color: #333;
  font-weight: 600;
  font-size: 28px;
  font-family: AlibabaPuHuiTiRegular;
  line-height: 42px;
}
.intro-card-text-content-intro___2w79Q {
  max-height: 300px;
  margin: 8px 0 0;
  padding-right: 8px;
  overflow: auto;
  color: #666;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: left;
  position: relative;
  bottom: 20px;
  /* width: 34vw; */
  max-width: 440px;
}
.intro-tips {
  font-size: 18px;
  margin-right: 0px;
  margin-left: 0px;
  color: #666;
  line-height: 1.5;
}

@media screen and(max-width: 401px) {
  .intro-tips {
    font-size: 24px;
    color: #666;
  }
  .tips-state {
    width: 100vw;
    font-size: 16px;
    margin-bottom: 30px;
    min-width: 800px;
    position: relative;
    bottom: 15px;
  }
  .intro-container {
    padding: 10px 60px 10px 50px;
  }
  .intro-card-text___2HNrP {
    max-width: 1072px;
    height: 400px;
    margin: 0 64px 0 0;
    padding: 56px 0 48px 64px;
    background-color: #f7f8fa;
    border-radius: 8px;
    position: relative;
    left: 70px;
    /* width: 75vw; */
  }
  .intro-card-image___2nwhu {
    position: absolute;
    bottom: 60px;
    width: 48%;
    height: 440px;
    left: 40px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 8px;
  }
  .intro-card-text___2HNrP {
    max-width: 1072px;
    height: 340px;
    margin: 0 64px 0 0;
    padding: 56px 0 48px 64px;
    background-color: #f7f8fa;
    border-radius: 8px;
    position: relative;
    left: 70px;
    width: 940px;
  }
  // .intro-card-text-content___1de2s {
  //   display: -webkit-box;
  //   display: flex;
  //   -ms-flex-direction: column;
  //   -webkit-box-orient: vertical;
  //   -webkit-box-direction: normal;
  //   flex-direction: column;
  //   width: 50%;
  //   height: 600px;
  //   padding: 0 60px 0 0;
  // }
  // .intro-card-text-content-intro___2w79Q {
  //   max-height: 340px;
  //   margin: 8px 0 0;
  //   padding-right: 8px;
  //   overflow: auto;
  //   color: #666;
  //   font-weight: 400;
  //   font-size: 24px;
  //   line-height: 28px;
  //   text-align: left;
  //   position: relative;
  //   bottom: 20px;
  //   /* width: 34vw; */
  //   max-width: 440px;
  // }
  .company-profile___XrpzK {
    max-width: 1128px;
    margin-right: auto;
    margin-bottom: 100px;
    margin-left: auto;
    padding-top: 80px;
    max-height: 1400px;
    min-height: 600px;
    min-width: 1128px;
    position: relative;
    left: 40px;
  }
  .case-image {
    width: 4vw;
    height: 4vw;
    border-radius: 8px;
    margin-right: 20px;
    max-width: 100px;
    max-height: 100px;
    min-width: 100px;
    min-height: 100px;
  }
  .case-box {
    margin: 5px 5px 30px 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .case-desc {
    min-width: 78vw;
    max-height: 30vh;
    padding-right: 4px;
    /* overflow-y: auto; */
    color: #333;
    font-weight: 400;
    font-size: 24px;
    line-height: 1.4;
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  /deep/ .el-dialog {
    position: relative;
    // margin: 0 auto 50px;
    background: #fff;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 50%;
    height: 1400px;
  }
  .el-dialog-div {
    height: 60vh;
    overflow: auto;
    padding: 10px 10px 20px 10px;
    min-height: 1200px;
  }
}
.intro-card-text-content-more___1L6qx {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 8vw;
  height: 7vh;
  margin: auto 0 0;
  color: #fff;
  background-image: linear-gradient(90deg, #1677ff, #1b99ff);
  border-radius: 4px;
  margin-top: 10px;
  max-width: 128px;
  max-height: 48px;
  min-width: 80px;
  max-height: 40px;
}
.click-test {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 120px;
  height: 30px;
  margin: auto 0 0;
  color: #fff;
  background-image: linear-gradient(90deg, #1677ff, #1b99ff);
  border-radius: 4px;
  margin-top: 10px;
}
.click-test .more-text {
  font-size: 10px;
  color: #fff;
}
.intro-card-text-content-more___1L6qx .more-arrow,
.intro-card-text-content-more___1L6qx .more-text {
  font-size: 12px;
  color: #fff;
}
.more-new___2QMxd .more-text {
  margin-right: 5px;
}
.more___FVQ2r .more-text {
  position: relative;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
  position: relative;
  bottom: 1px;
}
.textarea-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 30px;
}
.textarea-title {
  margin-bottom: 15px;
}
.pointer-move {
  position: relative;
  margin-left: 15px;
  animation: move 1s linear 0s infinite normal;
}
@keyframes move {
  0% {
    top: -3px;
  }
  25% {
    top: -2px;
  }
  50% {
    top: -1px;
  }
  75% {
    top: -2px;
  }
  100% {
    top: -3px;
  }
}
.result-box-success {
  padding: 20px 20px 20px 50px;
  width: 700px;
  background-color: rgba(42, 200, 108, 0.5);
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-radius: 20px;
  font-size: 20px;
  flex-wrap: wrap;
}
.result-box-error {
  padding: 20px 20px 20px 50px;
  width: 700px;
  background-color: rgba(177, 29, 51, 0.5);
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-radius: 20px;
  font-size: 20px;
  flex-wrap: wrap;
}
.result-box-warning {
  padding: 20px 20px 20px 50px;
  width: 700px;
  background-color: rgba(184, 145, 39, 0.5);
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-radius: 20px;
  font-size: 20px;
  flex-wrap: wrap;
}
.textarea-container {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}
.result {
  font-size: 16px;
  width: 600px;
  color: #fff;
}
.btn-box {
  position: relative;
  right: 120px;
  bottom: 60px;
  align-self: flex-end;
  display: flex;
  flex-wrap: nowrap;
}
.game-box {
  position: relative;
  right: 120px;
  bottom: 60px;
  align-self: flex-end;
  display: flex;
  flex-wrap: nowrap;
}
.tips-box {
  /* align-self: flex-start; */
  align-self: flex-start;
  margin-top: 10px;
  width: 300px;
  height: 26px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #ffffff;
  opacity: 1;
  position: relative;
  right: 110px;
  bottom: 45px;
  min-width: 300px;
  /* position: relative;
  right: 5vw;
  top: 3.5vh; */
}
.bottom-version {
  font-size: 0.8vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 25vh;
  background: rgb(30, 30, 60);
  opacity: 1;
  border-radius: 0px;
  max-height: 400px;
  min-height: 230px;
  min-width: 1200px;
}
.version-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 12px;
  height: 20px;
}
.version-image {
  width: 78px;
  height: 31px;
}
.bottom-text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #ffffff;
  opacity: 1;
  margin-left: 12px;
}
.syslogo {
  width: 31px;
  height: 25px;
  position: relative;
  left: 7px;
}
.test-title {
  color: #fff;
  font-family: PingFangSC-Thin;
  font-size: 50px;
  font-weight: 540;
  letter-spacing: 0;
  line-height: 48px;
  margin-top: 10px;
  padding-top: 60px;
  padding-bottom: 60px;
}
.testcase-container {
  background-image: url("../assets/usetest.png");
  width: 100%;
  height: 40vw;
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 1100px;
  min-height: 600px;
  min-width: 1200px;
}
.test-case-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.test-case {
  line-height: 1.5;
  padding: 20px 15px 10px 15px;
  font-size: 14px;
  margin: 0 20px 0 20px;
  width: 280px;
  height: 290px;
  background: #ffffff;
  box-shadow: 0px 3px 79px rgba(20, 85, 180, 0.25);
  opacity: 1;
  border-radius: 12px;
}
.result-icon {
  width: 16px;
  height: 16px;
  position: relative;
  top: 2px;
  margin-right: 2px;
}
.result-type {
  width: 150px;
}
.use-result-image {
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
}
.el-link.el-link--success {
  color: #11ea40;
}
.el-link.el-link--primary {
  font-size: 20px;
}
.el-button--mini {
  font-size: 20px;
}
/deep/ .el-dialog {
  position: relative;
  // margin: 0 auto 50px;
  background: #fff;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  height: 1400px;
}
</style>



// WEBPACK FOOTER //
// src/components/chatDetection.vue